import React, { useEffect, useState } from 'react';
import { Card, CardContent, Typography, Box, Divider, CardMedia, Grid, Button, IconButton, Icon } from '@mui/material';
import styled from '@emotion/styled';
import AttachMoneyRoundedIcon from '@mui/icons-material/AttachMoneyRounded';


import { formatGenericDate, formatCurrency } from '../../../utils/util';

import { SectionHeaderBar, BasicFlex, LabelUpper, autoCompleteDisplayLabel, DotSeparator } from '../../../utils/Common';

import { useFormikContext, FieldArray } from 'formik';

import { useFormData } from '../../../contexts/FormData';

import Field from '../../../utils/FormikFields/Field';

import useIsMobile from '../../../hooks/useIsMobile';


// linear-gradient(135deg, #f5f5f5 0%, #e8e8e8 100%);

const Container = styled.div`
  background-color: ${props => props.theme.colors.softBg};
  border-radius: 5px;
  padding: 1.5rem 1rem;
`

const InventoryListContainer = styled(BasicFlex)`
  margin-top: 1.5rem;
  width: 100%;
  gap: 1rem;
`;

const StyledCard = styled(Card)`
 border-radius: 8px;
 border: 1px solid ${props => props.theme.colors.border};
 box-shadow: 0 1px 5px rgba(0, 0, 0, 0.12);
 transition: all 0.2s ease-in-out;
 overflow: hidden;
 
 &:hover {
   border-color: ${props => props.theme.colors.darkBg};
   box-shadow: 0 2px 8px rgba(25, 118, 210, 0.1);
 }
`;

const ImageContainer = styled(BasicFlex)`
  background-image: linear-gradient(135deg, #f5f5f5 0%, #e8e8e8 100%);
  border-radius: 5px;
  border-right: 1px solid ${props => props.theme.colors.border};
  min-height: 8rem;
  width: 8rem;
  justify-content: center;
  align-items: center;
`;

const ServiceImage = styled('img')`
 width: 100%;
 height: 100%;
 object-fit: cover;
`;

const ServiceItemDetails = styled(BasicFlex)`
  min-width: fit-content;
  width: auto;
  margin-right: 10rem;
`;

const ServiceTitle = styled.div`
  text-transform: uppercase;
  font-weight: 600;
  font-size: 1.4rem;
  /* color: ${props => props.theme.colors.mildText}; */
  /* margin-bottom: .5rem; */
`

const DetailLineStyles = styled.div`
  /* font-size: 1.4rem; */
  color: ${props => props.theme.colors.mildText};
`;

const PriceDisplay = styled.div`
  height: min-content;

  .MuiInputBase-input {
    padding: .2rem !important;
  }
`

const WigInfo = styled(BasicFlex)`
  width: auto;
  flex-grow: 1;
`;

const InfoStatHeader = styled.div`
  font-weight: 500;
  text-transform: uppercase;
`

const InfoStatValue = styled.div`

` 

const InfoStat = ({ header, value }) => {
  return (
    <BasicFlex justify="space-between" dir="column" width="fit-content" gap=".5rem">
      <InfoStatHeader>
        {header}
      </InfoStatHeader>
      <InfoStatValue>
        {value}
      </InfoStatValue>
    </BasicFlex>
  )
}



const InventoryLine = ({ inventory = {}, index }) => {
  const { values } = useFormikContext() || {};
  let { image, name, sku, description } = inventory;

  console.log(values, "values");

  const { isMobile } = useIsMobile();

  return (
    <StyledCard sx={{p: ".8rem !important", width: "100%"}} variant='outlined'>
      <BasicFlex justify="flex-start">
        {/* <ImageContainer align="stretch">
        {image ? (
           <ServiceImage src={image} alt={sku} />
         ) : (
           <Face2RoundedIcon sx={{ fontSize: 32, color: '#bdbdbd' }} />
         )}
        </ImageContainer> */}
        <CardContent sx={{p: ".5rem 1.6rem !important", width: "100%"}}>
         <BasicFlex justify="space-between" dir={isMobile ? "column" : "row"} gap={isMobile ? "2rem" : "0"}>
          <ServiceItemDetails dir="column" gap=".5rem" align="flex-start">
            <ServiceTitle>{name}</ServiceTitle>
            <DetailLineStyles>{description}</DetailLineStyles>
          </ServiceItemDetails>

          <WigInfo justify="flex-start" gap="4rem">
            <InfoStat header="Sale Date" value={formatGenericDate(inventory?.sold_date)} />
            <InfoStat header="Sold To" value={inventory?.customer_name} />
            <InfoStat header="Sale Price" value={formatCurrency(inventory?.sold_price)} />
          </WigInfo>

          <div>
          <BasicFlex justify="space-between" dir="column" width="fit-content" gap=".5rem">
            <InfoStatHeader>
              Total Cost
            </InfoStatHeader>
            <InfoStatValue>
              <PriceDisplay>
              <Field name={`wigs.${index}.rate`} type="number" InputProps={{sx: {margin: 0, width: "12rem", paddingLeft: ".5rem !important", fontSize: "1.6rem", fontWeight: "500", gap: ".5rem"}, startAdornment: <AttachMoneyRoundedIcon fontSize='small' />}} />
              </PriceDisplay>
            </InfoStatValue>
          </BasicFlex>
          </div>
         </BasicFlex>

        </CardContent>
      </BasicFlex>
      
    </StyledCard>
  )
}

const Inventory = () => {
  const { values } = useFormikContext() || {};

  return ( values?.wigs?.length > 0 &&
    <Grid size={{xs: 12}} sx={{ marginTop: "1.5rem"}}>
       <Container>
        <LabelUpper>Sold Wigs</LabelUpper>
        <InventoryListContainer dir="column">
        { values.wigs.map((wig, index) => (
            <InventoryLine key={wig?.wig_id} inventory={wig} index={index} />
          ))}
        </InventoryListContainer>
          
      </Container>
    </Grid>
  )
};

export default Inventory;